export { default } from './ProtocolTemplateRouter';
